// Konfiguracja Firebase dla zdalnego loggera błędów.
//
// Uwaga: klucze web Firebase NIE są tajne - i tak trafiają do bundla klienta.
// Bezpieczeństwo zapewniają reguły Firestore (klient może tylko tworzyć logi),
// dlatego trzymamy config na stałe tutaj, bez zmiennych środowiskowych.
//
// Projekt: controls-ed80c

export const firebaseConfig = {
  apiKey: "AIzaSyCDUi3995y5zX6rjkqYAMoFdRDGsb8Z9Rg",
  authDomain: "controls-ed80c.firebaseapp.com",
  projectId: "controls-ed80c",
  storageBucket: "controls-ed80c.firebasestorage.app",
  messagingSenderId: "561953874948",
  appId: "1:561953874948:web:4222e6f6cec07b85b84151",
  measurementId: "G-03TP7TX1HW",
};

// Kolekcja w Firestore, do której trafiają logi błędów.
export const LOG_COLLECTION = "client_error_logs";
